import _ from 'lodash'
export default {
  state: {
    intents: [],
    selectedIntent: [],
    intentSamples: [],
    intentsPagination: {
      samples: {},
      intents: {},
    }
  },
  getters: {
    'nlp/intents/query': state => query => {
      const fallback = []
      if (!state.intents || !state.intents.length) return fallback
      const result = state.intents.filter(intent =>
        intent.name.toLowerCase().includes(query.toLowerCase())
      )
      return result && result.length ? result.reverse() : fallback
    },
    'nlp/intents/samples/query': state => query => {
      const fallback = []
      if (!state.intentSamples || !state.intentSamples.length) return fallback
      const result = state.intentSamples.filter(intent =>
        intent.utterance.toLowerCase().includes(query.toLowerCase())
      )
      return result && result.length ? result.reverse() : fallback
    }
  },
  mutations: {
    'nlp/intents/add': function(state, data) {
      state.intents.splice(0, 0, data)
    },
    'nlp/intents/set': function(state, data) {
      state.intents = data
    },
    'nlp/intents/select': function(state, data) {
      state.selectedIntent = data
    },
    'nlp/intents/samples/set': function(state, data) {
      state.intentSamples = data
    },
    'nlp/intents/samples/pagination/set': function(state, data) {
      state.intentsPagination.samples = data
    },
    'nlp/intents/list/pagination/set': function(state, data) {
      state.intentsPagination.intents = data
    }
  },
  actions: {
    'nlp/intents/get': async function({ commit, dispatch, state }, payload) {
      try {
        const params = _.omit(payload || {}, ['hideLoading'])
        const hideLoading = payload && payload.hideLoading
        if(!hideLoading) {
          dispatch('setLoader', true)
        }
        const { data } = await this._vm.$http_nlp.get(
          `/apps/${state.selectedApp.id}/intents`
          , { params }
        )
        if(!hideLoading) {
          dispatch('setLoader', false)
        }
        const { result } = data.data
        commit('nlp/intents/set', result)
        commit('nlp/intents/list/pagination/set', _.omit(data.data, ['result']))
        return result
      } catch (err) {
        dispatch('setLoader', false)
        commit('nlp/intents/set', [])
        throw new Error(err)
      }
    },
    'nlp/intents/get/single': async function({ state, commit }, id) {
      try {
        const { data } = await this._vm.$http_nlp.get(
          `/apps/${state.selectedApp.id}/intents/${id}`
        )
        commit('nlp/intents/select', data.data)
        return data.data
      } catch (err) {
        throw new Error(err)
        return false
      }
    },
    'nlp/intents/add': async function({ commit, dispatch, state }, payload) {
      try {
        const pack = payload
        // if(!payload.app) {
        //   pack.app = state.selectedApp.id
        // }
        const { data } = await this._vm.$http_nlp.post(
          `/apps/${state.selectedApp.id}/intents`,
          pack
        )
        dispatch('nlp/intents/get')
        return data
      } catch (err) {
        throw new Error(err)
      }
    },
    'nlp/intents/update': async function({ commit, dispatch, state }, payload) {
      try {
        const { data } = await this._vm.$http_nlp.put(
          `/apps/${state.selectedApp.id}/intents/${payload.id}`,
          { name: payload.name, ..._.omit(payload, 'id') }
        )
        dispatch('nlp/intents/get')
        return data
      } catch (err) {
        throw new Error(err)
      }
    },
    'nlp/intents/delete': async function({ state }, id) {
      try {
        await this._vm.$http_nlp.delete(
          `/apps/${state.selectedApp.id}/intents/${id}`
        )
        return true
      } catch (err) {
        throw new Error(err)
        return false
      }
    },
    'nlp/intents/delete/single': async function({ dispatch, state }, id) {
      try {
        await this._vm.$http_nlp.delete(
          `/apps/${state.selectedApp.id}/intents/${id}`
        )
        dispatch('nlp/intents/get')
        return true
      } catch (err) {
        throw new Error(err)
        return false
      }
    },
    'nlp/intents/single/sync': async function(
      { commit, dispatch, state },
      id
    ) {
      try {
        const { data } = await this._vm.$http_nlp.put(
          `/apps/${state.selectedApp.id}/intents/${id}/sync`
        )
        dispatch('nlp/intents/get')
        return data
      } catch (err) {
        throw err
      }
    },
    'nlp/intents/delete/multiple': async function(
      { dispatch, state },
      payload
    ) {
      try {
        dispatch('setLoader', true)
        let i
        for (i = 0; i < payload.length; i += 1) {
          try {
            await dispatch('nlp/intents/delete/single', payload[i].id)
          } catch (err) {
            dispatch('setLoader', false)
            throw new Error(err)
          }
        }
        dispatch('nlp/intents/get')
        return true
      } catch (err) {
        throw new Error(err)
      }
    },
    'nlp/intents/set': function({ commit }, data) {
      commit('nlp/intents/set', result)
      return result
    },
    'nlp/intents/select': function({ commit }, data) {
      commit('nlp/intents/select', data)
      return data
    },
    'nlp/intents/samples/get': async function(
      { commit, dispatch, state },
      payload
    ) {
      try {
        dispatch('setLoader', true)
        const { data } = await this._vm.$http_nlp.get(
          `/apps/${state.selectedApp.id}/intent_samples`,
          { params: { 'filter[intent]': state.selectedIntent.id, ...payload } }
        )
        dispatch('setLoader', false)
        const { result } = data.data
        commit('nlp/intents/samples/set', result)
        commit('nlp/intents/samples/pagination/set', _.omit(data.data, ['result']))
        return result
      } catch (err) {
        dispatch('setLoader', false)
        commit('nlp/intents/samples/set', [])
        throw new Error(err)
      }
    },
    'nlp/intents/samples/add': async function(
      { commit, state, dispatch },
      payload
    ) {
      try {
        dispatch('setLoader', true)
        if (!state.selectedIntent) {
          dispatch('setLoader', false)
          throw new Error('There is no selected intent')
          return false
        }
        const { data } = await this._vm.$http_nlp.post(
          `/apps/${state.selectedApp.id}/intent_samples`,
          { ...payload, intent: state.selectedIntent.id }
        )
        dispatch('setLoader', false)
        return data
      } catch (err) {
        dispatch('setLoader', false)
        throw new Error(err)
        return false
      }
    },
    'nlp/intents/samples/delete/single': async function(
      { dispatch, state },
      id
    ) {
      try {
        await this._vm.$http_nlp.delete(
          `/apps/${state.selectedApp.id}/intent_samples/${id}`
        )
        dispatch('nlp/intents/get')
        return true
      } catch (err) {
        throw new Error(err)
        return false
      }
    },
    'nlp/intents/samples/delete/multiple': async function(
      { dispatch, state },
      payload
    ) {
      try {
        dispatch('setLoader', true)
        let i
        for (i = 0; i < payload.length; i += 1) {
          try {
            await dispatch('nlp/intents/samples/delete/single', payload[i].id)
          } catch (err) {
            dispatch('setLoader', false)
            throw new Error(err)
          }
        }
        dispatch('nlp/intents/get')
        return true
      } catch (err) {
        throw new Error(err)
      }
    },
    'nlp/intents/samples/entities/add': async function(
      { commit, state, dispatch },
      payload
    ) {
      try {
        dispatch('setLoader', true)
        if (!state.selectedIntent) {
          dispatch('setLoader', false)
          throw new Error('There is no selected intent')
          return false
        }
        const { data } = await this._vm.$http_nlp.post(
          `/apps/${state.selectedApp.id}/intent_entity_labels`,
          payload
        )
        dispatch('setLoader', false)
        return data
      } catch (err) {
        dispatch('setLoader', false)
        throw new Error(err)
        return false
      }
    },
    'nlp/intents/samples/entities/delete': async function(
      { dispatch, state },
      id
    ) {
      try {
        await this._vm.$http_nlp.delete(
          `/apps/${state.selectedApp.id}/intent_entity_labels/${id}`
        )
        return true
      } catch (err) {
        throw new Error(err)
        return false
      }
    }
  }
}
